/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';


import { AppService } from '../api.service';
import { AnyTxtRecord } from 'dns';
import { DepartmentsService } from '../services/departments.service';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from '../services/project.service';
import { WindowService } from '../services/window.service';
import { isPlatformBrowser } from '@angular/common';
import { SearchService } from '../services/search.service';
import { fade, fadeInOut } from '../animations';
import { LocalStorageService } from '../services/localstorage.service';
import { Meta, Title } from '@angular/platform-browser';
import { HttpParams } from '@angular/common/http';
import { SearchLogService } from '../services/search-log.service';

import { QuickViewPopupService } from '../services/quick-view-popup.service';

import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject,Observable, of  } from 'rxjs';
import { trigger, transition, style, animate, keyframes } from '@angular/animations';

export interface Product {
  id: number;
  name: string;
  description: string;
  price: number;
  brand_name: string;
}

export interface SearchResponse {
  results: Product[];
  count: number;
  message: string;
}
@Component({
  selector: 'app-smart-view',
  templateUrl: './smart-view.component.html',
  styleUrls: ['./smart-view.component.scss'],
   animations: [fade,fadeInOut,
   trigger('bounceLoader', [
      transition(':enter', [
        animate(
          '1s ease-in-out',
          keyframes([
            style({ transform: 'scale(1)', offset: 0 }),
            style({ transform: 'scale(1.1)', offset: 0.5 }),
            style({ transform: 'scale(1)', offset: 1 })
          ])
        )
      ])
    ])
  ],
})
export class SmartViewComponent implements OnInit{
  searchControl = new FormControl();
  showPopup = false;
  loading = false;
  filteredSuggestions: any[] = [];
  items!: MenuItem[];
  project_id: any;
@ViewChild('searchInputBox') searchInputBox!: ElementRef;
  SearchTypes: any = [{ name: 'Product', code: 'product' }, { name: 'By SKU', code: 'sku' }]
  selectSearchType: any = this.SearchTypes[0];
  results: any[] = [];
  result!: string;
  isSearchActive!: boolean;
  activeFlow: any;
  activeCati!: any;
  sub_categorys: any[] = [];
  activeMenu!: string;
  bannerImgUrl: string="https://res.cloudinary.com/afterbricks/image/upload/v1727419101/Web_n63pc0.webp";
  isLoadingData: boolean = false;
  query: string = '';
  related_brands: any[] = [];
  global_loader: boolean = true;
  appointments: any[] = [];
  today_appointments: any[] = [];
  isDataNotFound!: boolean;
  is_pageLoad!: boolean;
  recognition: any;
  searchQuery: string = '';
  isListening: boolean = false;
  listeningTimeout: any;
  related_dealers: any[] = [];
  total_products: any;
  d_page: number = 1;
  page: number = 1;
  isSearchLoaded!: boolean;
  isBrandshow: boolean=false;
  isDealershow:boolean=false;
  smartmenusidebar:boolean=false;
  ecosystemsidebar:boolean=false;
  isDisclaimerpopup:boolean=false;
  last_query!: string;
  categoryId!:number;
  activeBrabdId: any;
  disclaimerpopupwidth!: string;
  sug_sub_categories: any[]=[];
  sug_product_types: any[]=[];
  isSuggetionPopUp!: boolean;
  sug_brands: any[]=[];
  sug_products: any[]=[];
  isProductLoader: boolean=false;
  selectedBrands: any[]=[];
  searchLogs: { query: string; timestamp: Date }[] = [];
  todayLogs: { query: string; timestamp: Date }[] = [];
  previousDayLogs: { query: string; timestamp: Date }[] = [];
  is_token!: boolean;
  activeQindex!: any;
  hoverQindex!:any;
  activeQuery!: { query: string; timestamp: Date; };
  isOverlayOpen:boolean=false;
  isMoreLoader!: boolean;
  total_brand_count: any;
  brands: any;
  isBrandSelecteLoader!: boolean;
  spaecs: any;

  suggestions: string[] = [];
  conversation: string[] = [];
  private searchSubject = new Subject<string>();
  products: Product[] = [];

  filters: any = { max_price: null, category: '', style: '', material: '', size: '' };
  connectionStatus: string = 'checking...';
  isSlow: boolean = false;
 
  // Sample data for suggestions
  popularSuggestions: string[] = [
    'Wooden flooring',
    'Marble countertops',
    'Modern wall paint',
    'LED ceiling lights',

  ];
  
  roomSuggestions: string[] = [
    'Living room furniture',
    'Kitchen backsplash',
    'Bathroom tiles',
    'Bedroom wallpaper',
    'Home office lighting'
  ];
  
  sampleQueries: string[] = [
    'Waterproof laminate flooring under rs 50/sqft',
    'Water and stain resistant flooring',
    'EStain resistant Touch-free faucets',
    'Scratch proof Vitrified flooring options',
    'Smart lighting solutions',
    'designer counter top basins for master bathroom',
    'Premium scratch proof tiles for bathroom',
    'Premium easy to clean kitchen sink',
    'Easy to install Scratch-resistant flooring',
    'Moisture resistant living room panels',
    'Durable and stylish kitchen cabinets',
    'Commercial grade carpet for offices'
  ];
  showSuggestionsFlag!: boolean;
  visibleQuery: string = '';
animatedIcons: string[] = [
  'https://s3-afterbricks.s3.amazonaws.com/media/work_image/34/Hb6b6cf32daf2414984f93221c531e79-removebg-preview.webp',
  'https://s3-afterbricks.s3.amazonaws.com/media/work_image/7/Bathfitting.webp',
  'https://s3-afterbricks.s3.amazonaws.com/media/work_image/9/woodwork.webp',
  'https://s3-afterbricks.s3.amazonaws.com/media/work_image/1/Tiles_and_flooring.webp',
   'https://s3-afterbricks.s3.amazonaws.com/media/work_image/14/Hardware.webp',
    'https://s3-afterbricks.s3.amazonaws.com/media/work_image/3/Electrical.webp'
];
isCollapsed = false;
  searchPlaceholder: string="Ask Smart Search for what you need — materials for home, office, or commercial upgrades";
visibleLimit = 10;
showAll = false;

isLoadingSuggestions = false;
smartSuggestions: string[] = [];
  input: any;
  messages: any[]=[];

followupQuestion = '';
  constructor(@Inject(PLATFORM_ID) private platformId: object, public _as: AppService, public _ds: DepartmentsService,public title: Title, public meta: Meta,public searchLogService: SearchLogService,
   private router: Router, private _actRoute: ActivatedRoute, public _project: ProjectsService, public _ss:SearchService,private localStorageService: LocalStorageService,public _qvs:QuickViewPopupService) {
    if (isPlatformBrowser(this.platformId)) {
      if (_as.isOnMobilePlatform) {
         this.bannerImgUrl = 'https://res.cloudinary.com/afterbricks/image/upload/v1727419066/Mobile_1_zlnerz.webp'
        
      } else {
        this.bannerImgUrl = 'https://res.cloudinary.com/afterbricks/image/upload/v1727419101/Web_n63pc0.webp';
      }
      // voise
      const SpeechRecognition = (window as any)['webkitSpeechRecognition'] || (window as any)['SpeechRecognition'];
      this.recognition = new SpeechRecognition();
      this.recognition.lang = 'en-US';  // You can set the language preference here
      this.recognition.interimResults = false;
      this.recognition.maxAlternatives = 1;

      this.recognition.onresult = (event: any) => {
        const speechResult = event.results[0][0].transcript;
        this._ss.query = speechResult;
        this.performSearch();  // Perform the search after capturing voice input
        this.stopListening()

      };
      this.recognition.onerror = (event: any) => {
        this.stopListening(); // Stop listening on error
      };
      this.recognition.onend = () => {
        this.isListening = false;
        clearTimeout(this.listeningTimeout); // Clear the timeout when recognition ends naturally
      };


      this.searchSubject.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe((query:any) => this.performSearch(query));
    }
   
  }

  ngOnInit() {
    this._qvs.displayQuickview  = false;
    if(this._as.isOnMobilePlatform){
      this.disclaimerpopupwidth='92%'
  
      }
      else{
        this.disclaimerpopupwidth='30vw'
      }
    if(!this.localStorageService.getItem('isDisclaimerpopup')){
      this.opendisclaimerpopup();
    }
    
    this._actRoute.queryParams.subscribe(pra => {
      // this._ss.query = pra['q'].replace('-', ' ');
      this.visibleQuery = pra['q'].replace('-', ' ');

    });

    // uncomment after don css work
    
    if(this._as.isUserLoggedIn){
      this.getLiveOffers();
      this.searchLogService.getAllSpacesWidthProductCount();
    }
    let is_run:boolean=false;
 
    setTimeout(() => {
      this._as.isLoggedIn1.subscribe((loggedIn) => { 
        if (loggedIn) {
          this.getLiveOffers();
          if (this.visibleQuery ) {
            
            this.globleSearch(true,false);
            is_run = true
          }
        }
      });
    }, 500);
    
    
    if (this.visibleQuery  && !is_run) {
      
      this.globleSearch(true,false);
    }
    this.setseoValue();
    this.loadSearchLogs();
  }

  startListening() {
    if (isPlatformBrowser(this.platformId)) {
      this.recognition.start();
      this.listeningTimeout = setTimeout(() => {
        this.stopListening();
      }, 10000); // 10,000 ms = 10 seconds
      this.isListening = true;
    }
  }

  performSearch(query: string = '') {
    if (isPlatformBrowser(this.platformId)) {
      // Implement your search logic, such as sending the query to your Django backend
      this.isListening = false;
      this.globleSearch(true,false)
    }
  }
  stopListening() {
    this.recognition.stop();
    
    clearTimeout(this.listeningTimeout); // Clear the timeout when stopping manually
    this.globleSearch(true,false);
    this.isListening = false;
  }

  onSearch(query: any) {
    // Optionally handle search input changes here
    const url = this._as.api_base_url + 'search/product-search1/?search=' + query + '&form';
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.filteredSuggestions = res.results;
      });
  }

  selectSuggestion(suggestion: any) {
    this.searchControl.setValue(suggestion.name);
    this.showPopup = false;
  }
  redirectTo(uri: string, queryParams: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri], { queryParams: queryParams }));
  }
  hoveDropdown(key: string) {
    this.activeMenu = key;
    if (key == '') {
      this.sub_categorys = [];
    }
  }
  setSubcategorydata(mci: number) {
    this.activeCati = mci;
    this.sub_categorys = this._ds.departments_list[mci].sub_category_list
  }

  globleSearch(isHtml:boolean,isMore?: any, page?: any) { 
    let url:any;
    let uuid;
    this._ss.query = this.visibleQuery;
    try{
      uuid = JSON.parse(this.localStorageService.getItem('uuid') || '')
    }catch{
      uuid = undefined
    }
    if(!this._ss.query){
      this.results = [];
      this.isProductLoader = false;
       this.router.navigate([], {
          relativeTo: this._actRoute,
          queryParams: {
            q: this._ss.query.replace(' ', '-')
          },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      return
    }

    if(this.selectedBrands.length && !isHtml){
      let params = new HttpParams().set('q', this._ss.query);
      if(page){
        params = params.append('page', page.toString());
      }else{
        page = 1
        params = params.append('page', page.toString());
      }
      this.selectedBrands.forEach(brand => {
        params = params.append('brand', brand);
      });
     params = params.append('uuid',uuid)
      url = this._as.api_base_url + 'search/product-search1/?'+params;
    }else{
      this.selectedBrands = [];
    url = this._as.api_base_url + 'search/product-search1/?q=' + this._ss.query + '&page='+this.page+'&uuid='+uuid;
    }
    
    // const url = this._as.api_base_url + 'product/search1/?search=' + this.query + '&page=' + this.page + '&d_page=' + this.d_page;
    if(!isMore && !this.isBrandSelecteLoader){
      this.isProductLoader= true;
    }
    if (this._ss.query.trim()) {
      this.searchLogService.saveSearchQuery(this._ss.query);
    }
    this.is_token = false;
    this.searchLogs = this.searchLogService.getSearchQueries();
    if(this.searchLogs.length > 3 && !this._as.isUserLoggedIn){
        this._as.isDisplayLogin = true;
        // return
    }else{
      this.is_token = true;
    }
    
    this._as.getRequest(url, this.is_token)
      .subscribe((res: any) => {
        if (isMore) {
          res.products.forEach((p: any) => { this.results.push(p) })
        } else {
          this.results = res.products;
        }

        if(this.results.length){
          this.categoryId = this.results[0].sub_category.id;
          this.activeBrabdId = this.results[0].brand.slug_name
        }else{
        this.last_query = this._ss.query;
        }
        this.last_query = this._ss.query;
        this.isSearchLoaded = true;
        this.total_products = res.product_paginator_info.total_count;
        if(!this.isBrandSelecteLoader){
          this.brands = res.brands;
          this.brands.forEach((b:any)=>b.status=false)
        this.related_brands = this.brands.slice(0,4);
        this.total_brand_count = res.brand_paginator_info.total_count;
        }
        
      
        this.isListening = false;
        this.router.navigate([], {
          relativeTo: this._actRoute,
          queryParams: {
            q: this._ss.query.replace(' ', '-')
          },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
        this.last_query = this._ss.query;
        this.isSuggetionPopUp = false;
        this.isProductLoader= false;
        this.isBrandSelecteLoader = false;
        this.loadSearchLogs();
        this.isMoreLoader=false;
        this.isSearchActive = true;
        this.visibleQuery = '';
    this.searchPlaceholder = 'Ask Smart Search for what you need — materials for home, office, or commercial upgrades';
          this.isBrandshow = false;
    this.scrollToSearchBox();
      this.showHideBrand();
      // this.getLLMSuggestions(this._ss.query) 
      },(err:any)=>{
         this.isSearchActive = true;
        this.isSuggetionPopUp = false;
        this.isProductLoader= false;
        this.isBrandSelecteLoader = false;
        this.isMoreLoader=false;
        this.isListening = false;
        this.isSearchLoaded = true;
        this.last_query = this._ss.query;
         this.visibleQuery = '';
         this._ss.query = '';
    this.searchPlaceholder = 'Ask Smart Search for what you need — materials for home, office, or commercial upgrades';
      this.scrollToSearchBox();
      });
  }
scrollToSearchBox(): void {
    if (this.searchInputBox && this._as.isOnMobilePlatform) {
      this.searchInputBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  // scrollToSearchBox(): void {
  //   if (this.isMobile() && this.searchInputBox) {
  //     this.searchInputBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   }
  // }
  onMoreProduct() {
    this.page = this.page + 1;
    this.isMoreLoader=true;
    this.globleSearch(false,true)
  }
  
  moreBrands(){
    this.related_brands = this.brands;
  }
  lessBrands(){
    this.related_brands = this.brands.slice(0,4)
  }
  showHideBrand(){
    if(this.isBrandshow){
      this.isBrandshow = false;
    }else{
      this.isBrandshow = true;
    }
  }
  openHideDealer(){
    if(this.isDealershow){
      this.isDealershow = false;
    }else{
      this.isDealershow = true;
    }
  }
  onOptionProduct(event: any) {
    const red_obj = event;
    let queryParams: any;
    let url: any;
    if (this.selectSearchType.code == 'sku') {
      queryParams = { fl: this.activeFlow, pId: this.project_id }
      url = 'p/' + red_obj.product_slug

    } else {
      queryParams = { subCat: red_obj.sub_category_id, category: red_obj.category_type, fl: this.activeFlow, pId: this.project_id }
      url = 'product/' + red_obj.slug_name

    }
    this.redirectTo(url, queryParams)
    this.result = '';
    this.isSearchActive = false;
  }
  onProductDetail(prod: any) {
    const red_obj = prod;
    const queryParams = { fl: this.activeFlow, pId: this.project_id }
    const  url = 'p/' + red_obj.slug

    this.redirectTo(url, queryParams)
    this.result = '';
    this.isSearchActive = false;
    this.isSuggetionPopUp = false;
  }
  getProductPageUrl(prod: any){
   
    const url = '../p/'+prod.slug
    return url
  }
  getQueryParams(){
    
    const queryParams = { fl: this.activeFlow, pId: this.project_id }
    return queryParams
  }
  getLiveOffers(form_type?: string, sub_category?: any) {
    this.isLoadingData = true;
    this._as.compareOffers = [];
    const url = this._as.api_base_url + 'user/live-offer-brands/?project=' + this._project.selectedProject.id + '&form_type=' + form_type;

    this._as.getRequest(url, true).subscribe((res: any) => {
      if (res) {
        this._as.compareOffers = res.brands_list;
      }
      this.isLoadingData = false;
    })
    this.getAppointments()
  }
  getAppointments() {
    const url = this._as.api_base_url + 'user/appointment/?project_id=' + this._project.selectedProject.id;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.global_loader = false;
        this.appointments = res.appointment_list;
        this.today_appointments = res.today_appointment_list;
        // this.setseoValue();
        if (!this.appointments.length && !this.today_appointments.length) {
          this.isDataNotFound = true;
        }
        else {
          this.isDataNotFound = false;
        }
        this.is_pageLoad = true;
      },
        (err: any) => {
          if (err) {
            this.global_loader = false;
          }
        });
        this.getAllSpacesWidthProductCount()
  }
  setseoValue() {
    
  
      this.title.setTitle('Smart Search for Interior Products | Credible Brands on Afterbricks');
      this.meta.updateTag({ property: 'og:title', content: 'Smart Search for Interior Products | Credible Brands on Afterbricks' });
      this.meta.updateTag({ property: 'og:image', content: this.bannerImgUrl });
      this.meta.updateTag({ property: 'image', content: this.bannerImgUrl });
      this.meta.updateTag({ name: 'description', content: "Search, sample and source, sustainable and high-quality materials & products for your interior design projects. Afterbricks' AI-powered Smart Search connects you with credible brands, making your search effortless, efficient & intuitive, saving you valuable time. | afterbricks.com" })
    
    this.meta.updateTag({ name: 'og:description', content: "Search, sample and source, sustainable and high-quality materials & products for your interior design projects. Afterbricks' AI-powered Smart Search connects you with credible brands, making your search effortless, efficient & intuitive, saving you valuable time. | afterbricks.com" })
    this.meta.updateTag({ property: 'og:url', content: this._as.site_url + this.router.url })
    this.meta.addTags([
      { name: 'robots', content: 'index, follow' },
      { charset: 'UTF-8' },
    ]);
  }


  smartMenusidebar(){
   this.smartmenusidebar = true;
  //  this.smartmenusidebar = false;
   
}

onEcosystemsidebar(){
    if(this.ecosystemsidebar){
    this.ecosystemsidebar = false;
    this.isDealershow = false;
    this.isBrandshow = false;
  }else{
    this.ecosystemsidebar = true;
    this.isDealershow = true;
    this.isBrandshow = true;
  }
    // this.ecosystemsidebar = false;
  }
  opendisclaimerpopup(){
    this.isDisclaimerpopup=true;
  }
  onDisclaimerok(){
  this.localStorageService.setItem('isDisclaimerpopup',JSON.stringify(this.isDisclaimerpopup))
  this.isDisclaimerpopup=false;
  }
  getAllSpacesWidthProductCount(){
    
    const url = this._as.api_base_url + 'search/space-product-colllection/' + this._project.selectedProject.id  + '/';
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
      
        this.spaecs = res.spaces;
       
        // this.results = res.results;
      });
  }
  newGlobleSearch(q:any){
    
    const url = this._as.api_base_url + 'search/search-suggestions/?q=' + q + '&form';
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
      
        this.sug_sub_categories = res.sub_categories;
        this.sug_product_types = res.product_types;
        this.sug_brands = res.brands;
        this.sug_products = res.products;
        // this.results = res.results;
      });
  }
  getSuggetionStatus(){
    if( this.sug_sub_categories?.length || this.sug_product_types?.length || this.sug_brands?.length || this.sug_products?.length){
      return true
    }else{
      return false
    }
  }
  focusSuggetionpup(){
    
      this.isSuggetionPopUp = true;
  }
  focusOutSuggetionpup(){
    setTimeout(() => {
      this.isSuggetionPopUp = false;
    }, 500);
  }
  getPriceUnit(calculation_type:any){
    if(calculation_type=='sqft_wise'){
      return 'sqft'
    }else{
      return undefined
    }
  
  }
  onBrandFilter(brand:any,bi:any){
    
    if(this.related_brands[bi].status){
      this.related_brands[bi].status = false;
      const sbi  =  this.selectedBrands.findIndex((slb:any)=>slb==brand.slug_name)
      
      this.selectedBrands.splice(sbi,1);
      
    }else{
      this.related_brands[bi].status = true;
      this.selectedBrands.push(brand.slug_name)
    }
    this.isBrandSelecteLoader = true;
    this.globleSearch(false,false)
  }

  getbrandStatus(slug_name:string){
    
    if(this.selectedBrands.find((sb:any)=>sb.slug_name==slug_name)){
      
      return true
    }else{
      
      return false
    }
  }
  loadSearchLogs(): void {
    this.searchLogs = this.searchLogService.getSearchQueries();
    const today = new Date();
    const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    // Split logs into today and previous days
    this.todayLogs = this.searchLogs
      .filter(log => new Date(log.timestamp) >= startOfToday)
      .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());

    this.previousDayLogs = this.searchLogs
      .filter(log => new Date(log.timestamp) < startOfToday)
      .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());

      const queryLog = this.searchLogs.find((sl:any)=>sl.query==this._ss.query) || undefined;

if(queryLog){
  this.activeQindex = this.searchLogs.findIndex((sl:any)=>sl.query==this._ss.query)
  this.activeQuery = queryLog;
  
}

  }

  deleteQuery(log: { query: string; timestamp: Date }): void {
    this.searchLogService.deleteSearchQuery(log);
    this.loadSearchLogs(); // Refresh the displayed list
  }

  clearAllQueries(): void {
    this.searchLogService.clearSearchQueries();
    this.loadSearchLogs();
  }
  getlogId(tli:any){
    return 'logId'+tli.string()
  }
selectQuery(log: { query: string; timestamp: Date },qIndex:number){
  this.activeQindex=qIndex;
  this.activeQuery = log;
  this.visibleQuery = log.query;
  this.smartmenusidebar = false;
  this.globleSearch(true)
}
  shareUrl(log: { query: string; timestamp: Date }) {
    const url ='/smart-search?q='+log.query.replace(' ', '-')
    const currentUrl = `${window.location.origin}${url}`;

    if (navigator.share) {
      navigator.share({
        title: document.title,
        text: log.query,
        url: currentUrl,
      })
      .then(() => console.log('Successful share'))
      .catch((error) => console.log('Error sharing', error));
    } else {
      // Fallback for browsers that don't support the Web Share API
      console.log("Share API not supported");
      alert("Web Share API not supported on this browser.");
    }
  }

  toggleOverlay(event: any, overlayPanel: any,qIndex:any) {
    this.hoverQindex=qIndex;
    this.isOverlayOpen = !this.isOverlayOpen;
    overlayPanel.toggle(event);
  }
  closeOverlay(overlayPanel: any) {
    overlayPanel.hide();
    this.isOverlayOpen = false;
    this.hoverQindex=undefined;
  }
 
  onHoverQrLog(qIndex:any){
    this.hoverQindex=qIndex;
    this.isOverlayOpen = true;
  }
//  For the conversation

onSearchv2() {
  if (this.query.trim()) {
    this.conversation.push(`You: ${this.query}`);
    this.searchSubject.next(this.query);
  }
}
applyFilter(filterType: string, value: any) {
  this.filters[filterType] = value;
  this.conversation.push(`You: Filter by ${filterType}: ${value}`);
  this.onSearchv2();
}

applySuggestion(suggestion: string) {
  if (suggestion.includes('style')) {
    this.applyFilter('style', 'modern'); // Example style
    this.conversation.push(`You: Show modern style panels`);
  } else if (suggestion.includes('material')) {
    this.applyFilter('material', 'wood'); // Example material
    this.conversation.push(`You: Show wooden panels`);
  } else if (suggestion.includes('size')) {
    this.applyFilter('size', 'large'); // Example size
    this.conversation.push(`You: Show large panels`);
  }
}

generateSuggestions(query: string): string[] {
  const terms = query.toLowerCase();
  console.log('terms',terms)
  const suggestions = [];
  console.log('terms 2',terms.includes('panel'))
  if (terms.includes('panel') || terms.includes('wall')) {
    suggestions.push('Do you have a particular style in mind for these decorative wall panels?');
    suggestions.push('Do you have a preferred material for these decorative wall panels?');
    suggestions.push('Do you have a specific size in mind for these decorative wall panels?');
  }
  if (terms.includes('cheap') || terms.includes('budget')) {
    suggestions.push('Show products under $100');
  }
  console.log('suggestions',suggestions)
  return suggestions;
}
  showSuggestions(): void {
    this.showSuggestionsFlag = this.searchQuery.length > 0;
  }

  selectSuggestion1(suggestion: string): void {
    this.searchQuery = suggestion;
    // this.onSearch();
  }

  selectSampleQuery(query: string): void {
    // this._ss.query = query;
    this.visibleQuery = query;
    this.globleSearch(true);
  }
get visibleSearchLogs() {
  return this.showAll ? this.searchLogs : this.searchLogs.slice(0, this.visibleLimit);
}

toggleShowAll() {
  this.showAll = !this.showAll;
}

getLLMSuggestions(query: string) {
  this.isLoadingSuggestions = true;
  this.smartSuggestions = [];
const url = this._as.api_base_url + 'search/llm-local-suggestions/?query=' + query;
this._as.getRequest(url, true).subscribe({
  next: (res: any) => {
    // this.smartSuggestions = res.suggestions || [];
    // this.isLoadingSuggestions = false;
     this.products = res.products || [];
      this.followupQuestion = res.followup_question?.[0] || '';
  },
  error: (err: any) => {
    console.error("LLM Suggestion error", err);
    this.isLoadingSuggestions = false;
  }
});
 
}

useSuggestion(suggestion: string) {
  // this.query = suggestion;
  // this.search(); // trigger your existing search logic
  this.visibleQuery = suggestion;
  this.globleSearch(true);
}

sendMessage() {
  const q = this.input;
  this.messages.push({ user: q, bot: '...' });
  const url = this._as.api_base_url + 'search/chat/';
  this._as.postRequest(url, { query: q },true).subscribe({
    next: (res: any) => {
      this.messages[this.messages.length - 1].bot = res.response;
    },
    error: (err: any) => {
      console.error('Error sending message:', err); 
      this.messages[this.messages.length - 1].bot = 'Sorry, I could not process your request at the moment.';
    }
  });
  
}
}
